<!--
 * @Author: zhaoliang
 * @Date: 2025-07-16 17:28:04
 * @LastEditTime: 2026-01-28 16:59:58
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/components/SafeInput/index.vue
 *
-->
<template>
  <input
    :class="[className, 'fs-mask']"
    type="text"
    :id="id"
    :placeholder="placeholder"
    autocomplete="off"
    :role="role"
    :value="displayValue"
    :maxlength="maxlength"
    :minlength="minlength"
    :disabled="disabled"
    @input="handleValueChange"
    @select="handleSelect"
    ref="safeInput"
    @keydown="handleKeyDown"
    @blur="handleBlur"
    @keyup="handleKeyUp"
  />
</template>
<script>
  export default {
    name: 'SafeInput',
    data() {
      return {
        cursorPosition: 0,
        displayValue: '',
        lastActualValue: '',
      };
    },
    emits: ['update:modelValue', 'input', 'change', 'select', 'keydown', 'keyup', 'blur'],
    // model: {
    //   event: 'change', // v-model 将监听这个事件
    // },
    watch: {
      modelValue(newValue) {
        const value = newValue;
        this.displayValue =
          this.type === 'password' ? value?.toString().replace(/./g, '•') : value || '';
        this.$nextTick(() => {
          if (this.lastActualValue !== value) {
            return;
          }
          const input = this.$refs.safeInput;
          input?.focus();
          input?.setSelectionRange(this.cursorPosition, this.cursorPosition);
        });
      },
      type(newVal) {
        const value = this.modelValue || '';
        if (newVal === 'password') {
          this.displayValue = value.toString().replace(/./g, '•') || '';
        } else {
          this.displayValue = value || '';
        }
      },
    },
    props: {
      className: {
        type: [Array, Object],
        default: [] | {},
      },
      type: {
        type: String,
        default: 'text',
      },
      id: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      autocomplete: {
        type: String,
        default: '',
      },
      role: {
        type: String,
        default: '',
      },
      maxlength: {
        type: [String, Number],
        default: '99' | 99,
      },
      minlength: {
        type: [String, Number],
        default: '0' | 0,
      },
      modelValue: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    mounted() {
      const value = this.modelValue || '';
      this.displayValue =
        this.type === 'password' ? value.toString().replace(/./g, '•') : value;
    },
    methods: {
      handleSelect(e) {
        const input = e.target;
        this.cursorPosition = input.selectionStart || 0;
        this.$emit('select', e);
      },
      handleKeyDown(e) {
        this.$emit('keydown', e);
      },
      handleBlur(e) {
        this.$emit('blur', e);
      },
      handleKeyUp(e) {
        this.$emit('keyup', e);
      },
      handleValueChange(e) {
        const input = e.target;
        this.cursorPosition = input.selectionStart || 0;

        // const { value } = this.value?.target || {};
        const value = this.modelValue || '';

        const newValue = e.target.value;
        const oldValue = value?.toString() || '';
        let actualValue = '';
        // 找到 newValue 中第一个非•字符之前的•字符数量
        const prefixBulletCount = newValue.match(/^[•]*/)?.[0]?.length || 0;
        // 找到 newValue 中第一个非•的位置
        const firstNonBulletIndex = newValue.split('').findIndex(char => char !== '•');
        //  找到 newValue 中最后一个非•字符之后的•字符数量
        const suffixBulletCount = newValue.match(/[•]*$/)?.[0]?.length || 0;
        // 找到 newValue 中最后一个非 • 的位置
        const lastNonBulleIndex = newValue
          .split('')
          .reduce((lastIndex, char, index) => (char !== '•' ? index : lastIndex), -1);

        // 处理特殊情况
        // newValue 中没有非•字符，并且长度减少, 说明进行了删除操作. 通过 cursorPositionRef.current 来确定光标位置, 判断从哪个位置删除的, 以及删除了多少个字符.
        if (
          firstNonBulletIndex === -1 &&
          (newValue.length < oldValue.length || newValue.length === oldValue.length)
        ) {
          const startIndex = this.cursorPosition;
          const endIndex = this.cursorPosition + oldValue.length - newValue.length;
          actualValue = oldValue.slice(0, startIndex) + oldValue.slice(endIndex);
        } else {
          actualValue =
            oldValue.slice(0, prefixBulletCount) +
            newValue.slice(firstNonBulletIndex, lastNonBulleIndex + 1) +
            // 从 oldValue 末尾开始，截取 suffixBulletCount 个字符
            (suffixBulletCount > 0 ? oldValue.slice(-suffixBulletCount) : '');
        }

        const event = {
          ...e,
          target: {
            ...e.target,
            value: actualValue,
          },
        };
        this.$emit('update:modelValue', actualValue);
        this.$emit('change', actualValue);
        this.$emit('input', event);
        if (this.lastActualValue === actualValue) {
          this.$nextTick(() => {
            this.displayValue =
              this.type === 'password' ? actualValue?.toString().replace(/./g, '•') : value || '';
          });
        } else {
          this.lastActualValue = actualValue;
        }
      },
    },
  };
</script>
<style lang="scss"></style>
